import React from "react";
import "../css/StageProgressView.css";
import greenArrowIcon from "../../assets/images/stage-green-arrow.svg";
import orangeArrowIcon from "../../assets/images/stage-orange-arrow.svg";
import whiteArrowIcon from "../../assets/images/stage-white-arrow.svg";
import stageProgressIcon from "../../assets/images/stage-progress-app-logo.svg";

interface StageProgressViewProps {
  current_stage: number;
}

const StageProgressView: React.FC<StageProgressViewProps> = ({
  current_stage,
}) => {
  const itemArr = ["Intention", "Arrive", "Focus", "Reflect", "Review"];

  return (
    <div className="stage-progress-view-container">
      {itemArr.map((stage, i) => {
        const index = i + 1;
        return (
          <>
            {index < current_stage ? (
              <div className="cell-container">
                <div className="completed-cell">✓</div>
                <span style={{color: "#C1F700"}}>{stage}</span>
              </div>
            ) : index === current_stage ? (
              <div className="cell-container">
                <div className="current-cell">
                  {<img src={stageProgressIcon} alt="stage-app-icon" />}
                </div>
                <span style={{color: "#FF6B35"}}>{stage}</span>
              </div>
            ) : (
              <div className="cell-container">
                <div className="cell">{index}</div>
                <span>{stage}</span>
              </div>
            )}

            {index < itemArr.length && (
              <img
                src={
                  index < current_stage
                    ? greenArrowIcon
                    : index === current_stage
                      ? orangeArrowIcon
                      : whiteArrowIcon
                }
                alt="arrow-icon"
              />
            )}
          </>
        );
      })}
    </div>
  );
};

export default StageProgressView;
